module.exports = __webpack_public_path__ + "static/media/YF16_7.87e4e796.jpg";